export default "__VITE_ASSET__ac54e003__"